import { useQuery } from 'react-query';
import { logger } from '@parrot-software/observability';

import { getConfigUseCases } from '@onboarding/composition';
import type { StoreBrandDto } from '@onboarding/application/dtos';

const onbLog = logger.forDomain('ONB');

/**
 * Fetches the store's brands to populate the brand fiscal section in the receipt step.
 *
 * Cached under ['onboarding', 'store-brands'] with infinite stale time so
 * it runs at most once per wizard session.
 */
export const useStoreBrands = () => {
  const { fetchStoreBrands } = getConfigUseCases();

  return useQuery<StoreBrandDto[], Error>(['onboarding', 'store-brands'], () => fetchStoreBrands.execute(), {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    retry: false,
    onError: (error) => {
      onbLog.warn('store_brands_fetch_failed', {
        'error.kind': error.constructor?.name ?? 'UnknownError',
        'error.message': error.message,
      });
    },
  });
};
